import { routes as listingRoutes } from './listings'
import { routes as stockRoutes } from './stocks'

export const routes = {
  ...stockRoutes,
  ...listingRoutes,
}
